import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MenuComponent } from './menu/menu.component';
import { FooterComponent } from './footer/footer.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { AccessMailRevalidateComponent } from './access-mail-revalidate/access-mail-revalidate.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HeaderComponent } from './header/header.component';

import { NavigationService } from './navigation.service';

import { NgxSkeletonModule } from 'ngx-skeleton';
import { ThemeModule } from 'src/app/@theme/theme.module';

@NgModule({
    declarations: [
        MenuComponent,
        FooterComponent,
        NotFoundComponent,
        AccessDeniedComponent,
        AccessMailRevalidateComponent,
        HeaderComponent,
    ],
    imports: [CommonModule, NgbModule, NgxSkeletonModule, ThemeModule],
    exports: [HeaderComponent, MenuComponent, FooterComponent, NotFoundComponent],
    providers: [NavigationService],
})
export class NavigationModule {}
